import * as Yup from 'yup';
import { l10nEnService } from '@uplift/services';
import { PASSWORD_MATCHES } from '@uplift/constants';

export const useSetPasswordValidationSchema = (l10n: typeof l10nEnService) => {
  return Yup.object().shape({
    password: Yup.string()
      .max(50, l10n.validations.tooLong)
      .required(l10n.validations.required)
      .matches(PASSWORD_MATCHES, l10n.validations.passwordMatches),
    confirmPassword: Yup.string()
      .oneOf([ Yup.ref('password') ], l10n.validations.passwordsDontMatch)
      .required(l10n.updatePassword.errors.confirmEmpty),
  });
};
